import { ActionType } from 'typesafe-actions';
import { call, put, takeLeading } from 'redux-saga/effects';
import { resolvePromiseAction, rejectPromiseAction } from 'redux-saga-promise-actions';

import GipsyApi from 'apis/GipsyGDS';
import Endpoints from 'endpoints';
import * as actions from '../actions';
import { AuthAgencyState } from '../types/authAgency';

function* signIn(action: ActionType<typeof actions.loginAgencyRequest.request>) {
  try {
    const {
      payload: { userName, password },
    } = action;
    const response: { data: AuthAgencyState } = yield call(GipsyApi.request, {
      method: 'post',
      url: Endpoints.loginPathAgency(),
      data: { userName, password },
    });

    localStorage.setItem(
      'authAgencyData',
      JSON.stringify({
        token: response.data.token,
      }),
    );

    const pinpadResponse: { data: any } = yield call(GipsyApi.request, {
      method: 'get',
      url: Endpoints.loginPinpadPath(),
      headers: {
        Authorization: `Bearer ${response.data.token}`,
      },
    });
    localStorage.setItem(
      'paramsPinpad',
      JSON.stringify({
        sitefIp: pinpadResponse.data.ip,
        storeId: pinpadResponse.data.sitefIdentification,
        cashierOperator: userName,
      }),
    );
    yield call(resolvePromiseAction, action, response.data);
    yield put(actions.loginAgencyRequest.success(response.data));
    yield put(
      actions.getPinpadLogin.success({
        sitefIp: pinpadResponse.data.ip,
        storeId: pinpadResponse.data.sitefIdentification,
      }),
    );
  } catch (error) {
    yield put(actions.loginAgencyRequest.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

export const watchAuthAgency = [takeLeading(actions.loginAgencyRequest.request, signIn)];
